import { render, staticRenderFns } from "./home-body.vue?vue&type=template&id=0a2fab1f&scoped=true&"
import script from "./home-body.vue?vue&type=script&lang=js&"
export * from "./home-body.vue?vue&type=script&lang=js&"
import style0 from "./home-body.vue?vue&type=style&index=0&id=0a2fab1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fab1f",
  null
  
)

export default component.exports